export type Entry = {[_: string]: any, [Data.idxSymbol]?: number}

export default class Data {
	static readonly idxSymbol = Symbol("Data.idx")
	
	data: { entries: Entry[], columns?: string[], inputColumns?: string[] }
	columns: string[]
	
	constructor(data: {entries: Entry[], columns?: string[], inputColumns?: string[]}) {
		this.setData(data)
	}

	get entries(): Entry[] { return this.data.entries }
	set entries(entries: Entry[]) { this.data.entries = entries }

	setData(data: {entries: Entry[], columns?: string[], inputColumns?: string[]}) {
		this.data = data
		this.columns = data.columns
			?? Object.keys(data.entries[0]).sort()

		// Remove empty entries
		this.entries = this.entries.filter(this.isNonemptyEntry.bind(this))
		this.entries.forEach((entry, i) => entry[Data.idxSymbol] = i)
	}

	sort(by: string, descending: boolean) {
		// Pre-create collator for significant performance improvement
		// over `a.localeCompare(b, undefined, {sensitivity: "base"})`
		// funny / weird thing: for localeCompare, supplying an empty `options`
		// object is way slower than supplying nothing...
		const collator = new Intl.Collator(undefined, { sensitivity: "base" })
		
		const order = (descending ? -1 : 1)

		// When a and b are both numbers, compare as numbers.
		// Otherwise, case-insensitive compare as string.
		// Convert undefined values to -inf to sort them last
		this.entries = this.entries.sort((a_row, b_row) => {
			const a = a_row[by] ?? Number.NEGATIVE_INFINITY
			const b = b_row[by] ?? Number.NEGATIVE_INFINITY
			if (!isNaN(Number(a)) && !isNaN(Number(b))) {
				return order * (a - b)
			} else {
				return order * collator.compare(a, b)
			}
		})
	}

	// Ignore all entries which have no scores
	isNonemptyEntry = (entry: Entry): boolean => this.columns
		.filter(column => entry[column] != undefined).length > 0

	// Array-like filter function for objects
	// https://stackoverflow.com/a/37616104
	static filter = (obj: {}, predicate: (_: any) => boolean): {} =>
		Object.fromEntries(Object.entries(obj).filter(([_, v]) => predicate(v)))

}
